import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

export default function AIUserScorecard() {
  const authState = useSelector((state) => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName] = useState(authState.user.name);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const aiuRankings = [
    { name: "सुनीता गावंडे", place: "नागपूर (Urban)" },
    { name: "मीनाक्षी पाटील", place: "कोल्हापूर (Rural)" },
    { name: "संध्या पवार", place: "पुणे (Urban)" },
    { name: "रेखा जाधव", place: "औरंगाबाद (Rural)" },
    { name: "आशा भोसले", place: "नाशिक (Urban)" },
    { name: "शालिनी शिंदे", place: "सांगली (Rural)" },
    { name: "कविता कदम", place: "ठाणे (Urban)" },
    { name: "लता मोरे", place: "अमरावती (Rural)" },
    { name: "वंदना देशमुख", place: "सोलापूर (Urban)" },
    { name: "प्रेमिला पाटील", place: "रत्नागिरी (Rural)" },
  ];

  const today = new Date().toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="flex flex-col min-h-screen bg-black text-white font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-black-500 shadow-md px-4 py-2 flex justify-between">
        <div>
          <h1 className="text-sm lg:text-lg font-bold text-yellow-200">
            🤖 AI User Rankings
          </h1>
          <p className="text-xs lg:text-sm text-gray-300">
            Ranking and Rewards for User using AIs
          </p>
        </div>

        <div className="flex items-center gap-3">
          {isLoggedIn && (
            <div className="hidden md:flex flex-col items-center">
              <span className="text-xs lg:text-sm">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-8 h-8 rounded-full bg-black-500 hover:bg-black-600 flex items-center justify-center"
              >
                ⏻
              </button>
            </div>
          )}

          <button
            onClick={() => setIsMobileMenuOpen((s) => !s)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-xl bg-black-700 rounded-md"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-black text-white border-y border-black-400 px-4 py-3 flex flex-col space-y-3">
          {isLoggedIn && (
            <>
              <p className="text-xs">{userName}</p>
              <button
                onClick={handleLogout}
                className="bg-black-500 rounded px-4 py-2 text-sm hover:bg-black-600 w-full"
              >
                Logout
              </button>
            </>
          )}
        </nav>
      )}

      {/* ---------- MAIN CONTENT (scrollable) ---------- */}
      <main className="flex-1 overflow-auto px-4 py-3">

        <h2 className="text-center text-sm lg:text-lg font-semibold text-yellow-400 mb-3">
          🏅 AI Users Rankings today : {today}
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
          {aiuRankings.map((aiu, index) => (
            <div
              key={index}
              className="bg-black-800/60 rounded-xl shadow-md border border-black-700 p-4 text-center hover:bg-black-700/70 transition"
            >
              <div className="text-sm font-bold text-yellow-200">
                #{index + 1}
              </div>
              <div className="text-sm font-semibold mt-1">{aiu.name}</div>
              <div className="text-xs text-gray-300">{aiu.place}</div>
            </div>
          ))}
        </div>

      </main>

      <footer className="sticky bottom-0 z-50 bg-black border-t border-pink-300 px-4 py-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-xs sm:text-sm gap-2">
          <p>© 2025 Think5Whys Global DeepTech Solutions.</p>

          <div className="flex gap-4">
            <Link to="/about-us" className="hover:text-pink-200">About</Link>
            <Link to="/privacy-policy" className="hover:text-pink-200">Privacy</Link>
            <Link to="/terms-of-use" className="hover:text-pink-200">Terms</Link>
            <Link to="/contact-us" className="hover:text-pink-200">Contact</Link>
          </div>
        </div>
      </footer>

    </div>
  );
}
